import dayjs from "dayjs";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import "./FiltersBar.css";

export default function FiltersBar({ filters, setFilters, onApply, onReset }) {
  return (
    <div className="fbWrap">
      <div className="fbHead">
        <div className="fbHeadLeft">
          <div className="fbTitle">Filters</div>
          <div className="fbSub">Search, date range, type, receiver — then apply.</div>
        </div>

        <div className="fbDatePill" title="Today">
          <CalendarMonthOutlinedIcon style={{ fontSize: 18, opacity: 0.9 }} />
          {dayjs().format("DD MMM, YYYY")}
        </div>
      </div>

      <div className="fbBody">
        <div className="fbGrid">
          <div className="fbField fbFrom">
            <label>From</label>
            <input
              className="fbControl"
              type="date"
              value={filters.from || ""}
              onChange={(e) => setFilters((p) => ({ ...p, from: e.target.value }))}
            />
          </div>

          <div className="fbField fbTo">
            <label>To</label>
            <input
              className="fbControl"
              type="date"
              value={filters.to || ""}
              onChange={(e) => setFilters((p) => ({ ...p, to: e.target.value }))}
            />
          </div>

          <div className="fbField fbType">
            <label>Type</label>
            <select
              className="fbControl"
              value={filters.type || ""}
              onChange={(e) => setFilters((p) => ({ ...p, type: e.target.value }))}
            >
              <option value="">All</option>
              <option value="full">Full</option>
              <option value="partial">Partial</option>
            </select>
          </div>

          <div className="fbField fbReceiver">
            <label>Receiver</label>
            <input
              className="fbControl"
              placeholder="Optional"
              value={filters.receiver || ""}
              onChange={(e) => setFilters((p) => ({ ...p, receiver: e.target.value }))}
            />
          </div>

          <div className="fbField fbSearch">
            <label>Search</label>
            <input
              className="fbControl"
              placeholder="Title / description / receiver"
              value={filters.q || ""}
              onChange={(e) => setFilters((p) => ({ ...p, q: e.target.value }))}
            />
          </div>

          <div className="fbActionsCell">
            <label style={{ visibility: "hidden" }}>Actions</label>
            <div className="fbActions">
              <button className="fbBtn fbBtnPrimary" onClick={onApply}>Apply</button>
              <button className="fbBtn" onClick={onReset}>Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
